module.exports = __webpack_public_path__ + "static/media/event-dashboard.e76617e1.svg";